(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["peak-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var header   = document.querySelector('.peak-header');
  var announce = document.querySelector('.peak-header__announce');
  var nav      = document.querySelector('.peak-header__nav-wrap');
  if (!header) return;

  function measure() {
    var headerH   = header.offsetHeight || 0;
    var announceH = announce ? announce.offsetHeight : 0;
    document.documentElement.style.setProperty('--peak-header-h', headerH + 'px');
    document.documentElement.style.setProperty('--peak-announce-h', announceH + 'px');
  }
  measure();
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);

  var raf = null;
  function update() {
    raf = null;
    var threshold = announce ? announce.offsetHeight : 0;
    if (window.scrollY > threshold) {
      header.classList.add('is-condensed');
      if (nav) nav.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-condensed');
      if (nav) nav.classList.remove('is-scrolled');
    }
  }
  window.addEventListener('scroll', function () {
    if (raf == null) raf = window.requestAnimationFrame(update);
  }, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peak-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var roots = document.querySelectorAll('[data-peak-reviews]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      /* Guard: don't bind twice if the section re-renders in the editor */
      if (root.dataset.peakReviewsReady === '1') return;
      root.dataset.peakReviewsReady = '1';

      var track = root.querySelector('[data-peak-reviews-track]');
      var prev  = root.querySelector('[data-peak-reviews-prev]');
      var next  = root.querySelector('[data-peak-reviews-next]');
      if (!track) return;

      /* Detect smooth scrollBy support so we don't error on old browsers. */
      var supportsSmooth = (function () {
        try {
          var t = document.createElement('div');
          t.style.overflow = 'hidden';
          return ('scrollBehavior' in t.style);
        } catch (e) { return false; }
      })();

      function slideWidth() {
        var first = track.firstElementChild;
        if (!first) return 0;
        var cs  = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      /* Wrap-around step: clicking next at the end smoothly scrolls
         back to the start; clicking prev at the start scrolls to the
         end. Means the arrows ALWAYS produce visible motion, so the
         slider feels alive even with only 3 reviews. */
      function step(dir) {
        var sw  = slideWidth();
        if (!sw) return;
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        var cur = track.scrollLeft;
        var target;

        if (dir > 0) {
          target = (cur >= max - 4) ? 0 : Math.min(cur + sw, max);
        } else {
          target = (cur <= 4) ? max : Math.max(cur - sw, 0);
        }

        if (supportsSmooth && typeof track.scrollTo === 'function') {
          track.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          track.scrollLeft = target;
        }
      }

      /* Arrows stay active always (wrap-around) — we only soft-dim
         them when there is genuinely nothing to scroll (1 slide
         total or container wider than content). */
      function updateArrows() {
        if (!prev && !next) return;
        var hasOverflow = track.scrollWidth > track.clientWidth + 2;
        if (prev) prev.disabled = !hasOverflow;
        if (next) next.disabled = !hasOverflow;
      }

      function bind(btn, dir) {
        if (!btn) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          step(dir);
        });
      }
      bind(prev, -1);
      bind(next,  1);

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      /* Initial pass + a follow-up after images/fonts settle so the
         disabled state matches the real scrollWidth on first paint. */
      updateArrows();
      window.addEventListener('load', updateArrows);
      setTimeout(updateArrows, 250);
    });
  }

  /* Run as soon as the DOM is parsed; if it already is, run now. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* In the Shopify theme editor, re-bind when this section is reloaded. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target && e.target.querySelector('[data-peak-reviews]')) init();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
